import { Trans } from '@lingui/macro';
import { TableHead, TableRow, TableHeadCell, TableHeaderText, VisuallyHidden, } from '@pocketlaw/tetris';
export function KeyTableHead() {
    return (<TableHead>
      <TableRow>
        <TableHeadCell id="title">
          <TableHeaderText>
            <Trans comment="Key Table - Title">Title</Trans>
          </TableHeaderText>
        </TableHeadCell>
        <TableHeadCell id="description">
          <TableHeaderText>
            <Trans comment="Key Table - Description">Description</Trans>
          </TableHeaderText>
        </TableHeadCell>
        <TableHeadCell id="clientId">
          <TableHeaderText>
            <Trans comment="Key Table - Client ID">Client ID</Trans>
          </TableHeaderText>
        </TableHeadCell>
        <TableHeadCell id="createdBy">
          <TableHeaderText>
            <Trans comment="Key Table - Created By">Created By</Trans>
          </TableHeaderText>
        </TableHeadCell>
        <TableHeadCell id="edit" stickyColumn="right">
          <VisuallyHidden>
            <TableHeaderText>
              <Trans comment="Key Table - Edit (screen reader only)">Edit</Trans>
            </TableHeaderText>
          </VisuallyHidden>
        </TableHeadCell>
      </TableRow>
    </TableHead>);
}
